//$( ".cross" ).hide();
$( ".menu" ).hide();
$( ".hamburger" ).click(function() {
$( ".menu" ).slideToggle( "fast", function() {
	//$( ".hamburger" ).show();
});
});

//$( ".cross" ).click(function() {
//$( ".menu" ).slideToggle( "fast", function() {
//$( ".cross" ).hide();
//$( ".hamburger" ).show();
//});
//});